import React,{useState} from "react";
import "./QRcode.css";
const QRcode=()=>{
    let [data,setData]=useState("");
    let [size,setSize]=useState("");
    let [margin,setMargin]=useState("");
    let [color,setColor]=useState("");
    let [bgcolor,setBgcolor]=useState("");
    return(
        <section className="qrfield-Block">
            <article>
                <form>
                    <textarea rows="20" cols="40" placeholder="Enter text for generate QRcode..." value={data} onChange={e =>setData(e.target.value)}></textarea>
                    <br/>
                    <label for="size">Size(max-900)</label>
                    <input type="text" value={size} id="size"placeholder="size" maxLength={3} onChange={e =>setSize(e.target.value)}/>
                    <br/>
                    <label for="margin">Margin</label>
                    <input type="text" value={margin} id="margin"placeholder="margin" onChange={e =>setMargin(e.target.value)}/>
                    <br/>
                    <label for="color">Color(rbg)</label>
                    <input type="text" value={color} id="color"placeholder="color" onChange={e =>setColor(e.target.value)}/>
                    <br/>
                    <label for="bgcolor">Bg-color(rbg)</label>
                    <input type="text" value={bgcolor} id="bgcolor"placeholder="bgcolor" onChange={e =>setBgcolor(e.target.value)}/>
                    <br/>
                </form>
                <div className="qr-code-Block">
                    <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${data}&size=${size}x${size}&margin=${margin}&color=${color}&bgcolor=${bgcolor}`} alt="QRcode not available"/> 
                    <a href={`https://api.qrserver.com/v1/create-qr-code/?data=${data}&size=${size}&margin=${margin}&color=${color}&bgcolor=${bgcolor}`}download> Download QRCode</a>
                </div>
            </article>
            
        </section>
    )
}
export{QRcode}